import crud_actions from './crud_actions'
export const CLEAR_POSTS = 'clear_found_posts'
export const CLEAR_POST = 'clear_post'

export const loadInterestingPosts = crud_actions.read(
  'posts',
  'loadInterestingPosts'
)
export const loadInterestingEvents = crud_actions.read(
  'posts',
  'loadInterestingEvents'
)
export const loadFilteredPosts = crud_actions.read('posts', 'loadFilteredPosts')
export const loadFilteredEvents = crud_actions.read('posts', 'loadFilteredEvents')
export const loadTaggedPosts = crud_actions.read('posts', 'loadTaggedPosts')
export const loadPublishedPosts = crud_actions.read('posts', 'loadMemberPosts')
export const loadPublishedEvents = crud_actions.read('posts', 'loadMemberEvents')
export const loadPublishedPost = crud_actions.read(
  'post',
  'loadPostByUsernameAndPostName'
)
export const loadPublishedPostByUsername = loadPublishedPost
export const loadPublishedPostById = crud_actions.read('post', 'loadPostById')

export const loadPublishedResponses = crud_actions.read(
  'posts',
  'loadMemberResponses'
)
export const addZoomToPost = crud_actions.update('post', 'addZoomToPost')
export const createZoomMeeting = crud_actions.update("post", "createZoomMeeting")
export const concludePost = crud_actions.update('post', 'concludePost')

export const loadGroupPosts = crud_actions.read('posts', 'loadGroupPosts')

export const loadReferencesForGroup = crud_actions.read(
  'references',
  'loadReferencesForGroup'
)

export const unpublishPost = crud_actions.delete('post', 'unpublishPost')

export const suggestPosts = crud_actions.read('posts', 'suggestPosts')
export const clearPosts = opts => {
  return {
    type: CLEAR_POSTS,
    payload: opts
  }
}

export const clearPost = () => {
  return {
    type: CLEAR_POST,
  }
}

export const ratePost = crud_actions.update('post', 'ratePost')

export const goToPost = ({ name, username, group, _id, meta }) => {
  if ((group && group.group) || typeof group === 'string') {
    return {
      type: 'groups/group/posts/post',
      payload: {
        group: (group.group && group.group._id) || group.group || group,
        post: _id
      },
      meta
    }
  } else {
    return {
      type: 'home/member/posts/post',
      payload: {
        postType: 'article',
        username,
        name
      },
      meta
    }
  }
}
